import { BOOK_SALES_DEMO_SOURCES, useOpenBookSalesDemo } from '@/entities/demoBooking';

import { useOpenPricingPage } from '@/shared/hooks/useOpenPricingPage';
import { useInterfaceLanguage } from '@/shared/i18n';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { getOnscreenPaywallCtaKey } from '../lib/getOnscreenPaywallCtaKey';
import { useOnscreenAccess } from './useOnscreenAccess';

export const ONSCREEN_PAYWALL_VARIANT = 'visualTranslation';

type UseOnscreenPaywallCtaParams = {
  pricingEntryPoint: PricingEntryPoint;
  // Closes the paywall itself, whichever way the user goes.
  onLeave?: () => void;
  onLeaveForPricing?: () => void;
};

// The paywall's one button: plans below Business go to pricing, Business and Enterprise talk to sales about the add-on.
export const useOnscreenPaywallCta = ({
  pricingEntryPoint,
  onLeave,
  onLeaveForPricing,
}: UseOnscreenPaywallCtaParams) => {
  const { t } = useInterfaceLanguage();
  const { offer } = useOnscreenAccess();
  const openPricingPage = useOpenPricingPage();
  const openBookSalesDemo = useOpenBookSalesDemo();

  const ctaLabel = t(getOnscreenPaywallCtaKey(offer));

  const onCta = () => {
    onLeave?.();

    if (offer === 'addOn') {
      openBookSalesDemo(BOOK_SALES_DEMO_SOURCES.visualTranslationPaywall, ctaLabel);
      return;
    }

    MixpanelEvents.viewPlanPaywallClick({
      paywall_variant: ONSCREEN_PAYWALL_VARIANT,
      pricing_entry_point: pricingEntryPoint,
    });
    onLeaveForPricing?.();
    openPricingPage(pricingEntryPoint);
  };

  return { offer, onCta };
};
